import { Children, Fragment, ReactNode } from 'react';

import {
  Divider,
  MetricsBox,
  SquareMarker,
  Box,
  Stack,
} from '@cast/design-system';

const UtilizationMarker = () => (
  <Box
    sx={{
      width: 12,
      height: 12,
      borderRadius: '2px',
      border: '2px dashed',
      borderColor: 'yellow.800',
      flexShrink: 0,
    }}
  />
);

type DashboardChartSummaryMetricProps = {
  color?: string;
  dashedMarker?: boolean;
  infoTooltip?: ReactNode;
  label: string;
  unit?: ReactNode;
  value: ReactNode;
};

export const DashboardChartSummaryMetric = ({
  color,
  dashedMarker,
  infoTooltip,
  label,
  unit,
  value,
}: DashboardChartSummaryMetricProps) => (
  <MetricsBox
    size="m"
    slots={{
      startContent: dashedMarker ? (
        <UtilizationMarker />
      ) : color ? (
        <SquareMarker color={color} />
      ) : undefined,
      label,
      infoTooltip,
      value,
      unit,
    }}
  />
);

type DashboardChartSummaryMetricsRowProps = {
  children: ReactNode;
  alwaysRow?: boolean;
};

export const DashboardChartSummaryMetricsRow = ({
  children,
  alwaysRow = false,
}: DashboardChartSummaryMetricsRowProps) => {
  const items = Children.toArray(children);

  return (
    <Stack
      direction={alwaysRow ? 'row' : { none: 'column', laptop: 'row' }}
      alignItems="stretch"
      gap={12}
      sx={{ '& > *:not(.MuiDivider-root)': { flex: 1, minWidth: 0 } }}
    >
      {items.map((child, index) => (
        <Fragment key={index}>
          {index > 0 ? (
            <Divider
              flexItem
              orientation="vertical"
              sx={
                alwaysRow
                  ? undefined
                  : { display: { none: 'none', laptop: 'block' } }
              }
            />
          ) : null}
          {child}
        </Fragment>
      ))}
    </Stack>
  );
};
